/* eslint-disable react/require-default-props */
import { BtnAnch } from 'components/elements/global'
import { FC, useMemo } from 'react'
import useChat from '../hooks/useChat'

const ChatHeader: FC<{
 onClose?: () => void
 onBack?: () => void
}> = ({ onBack, onClose }) => {
 const { state, toggleMinimize } = useChat()
 const { screen } = state

 const showBack = useMemo(() => {
  switch (screen) {
   case 'chatMessage':
   case 'chatProHistory':
    return true
   default:
    return false
  }
 }, [screen])

 const handleClickMinimize = () => {
  toggleMinimize?.()
 }

 return (
  <div className="chat-header">
   <div className="chat-hd-title">
    {showBack && (
     <BtnAnch onClick={onBack}>
      <i className="fas fa-arrow-left me-1" />
     </BtnAnch>
    )}
    Chat
   </div>
   <div className="chat-hd-action">
    {/* <BtnAnch onClick={handleClickMinimize} className="me-2">
     <i
      className={state.minimized ? 'fal fa-square me-2' : 'fal fa-minus me-2'}
     />
    </BtnAnch> */}
    <BtnAnch onClick={onClose}>
     <i className="far fa-times" />{' '}
    </BtnAnch>
   </div>
  </div>
 )
}

export default ChatHeader
